import { ErrorMessage, Field, useField } from "formik";
import { FormGroup, Label } from "reactstrap";

type CustomSelectInputProps = {
  label: string;
  name: string;
  type: string;
  fieldClassName: string;
  errorComponent?: React.ComponentType<any> | string;
  children?: React.ReactNode; // Include children prop
  handleOnChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  labelClassName?: string;
};

export const CustomSelectInput = ({
  label,
  name,
  type,
  fieldClassName,
  errorComponent = "div",
  children,
  handleOnChange,
  disabled,
  labelClassName = "",
}: CustomSelectInputProps) => {
  const [field, { touched, error }] = useField(name);
  // Destructure onChange from Formik's field object
  const { onChange: onFieldChange, ...restField } = field;

  // Combine Formik's onChange and custom handleOnChange
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (handleOnChange) {
      handleOnChange(event); // Call custom onChange
    }
    onFieldChange(event); // Call Formik's onChange
  };

  return (
    <FormGroup>
      <Label className={`col-form-label ${labelClassName}`}>{label}</Label>
      <Field
        as={type}
        className={`f-12 ${fieldClassName}`}
        {...restField}
        disabled={disabled}
        onChange={handleChange} // Use combined onChange logic
      >
        <option value="" disabled>
          Select
        </option>
        {children}
      </Field>
      {touched && error && (
        <ErrorMessage
          name={name}
          component={errorComponent}
          className="invalid-feedback"
        />
      )}
    </FormGroup>
  );
};
